import * as React from "react"
import { svgIconStyles } from "@digits-shared/components/SVG/svgIconStyles"
import { SvgDigitsLogoNoBackground } from "@digits-shared/components/SVGIcons/digits/DigitsLogoNoBackground.svg"
import { SvgDigitsWordmark } from "@digits-shared/components/SVGIcons/digits/DigitsWordmark.svg"
import colors from "@digits-shared/themes/colors"
import { H1Text } from "@digits-shared/themes/typography"
import styled from "styled-components"

/*
  STYLES
*/

const CTAImage = styled.img`
  position: fixed;
  right: 0;
  min-width: 600px;
  max-width: min(70vw, 1000px);
  z-index: -1;
`
const ImageWidthPlaceholder = styled.div`
  flex: 1;
`

const SharedWithMeCallToActionContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: calc(100% - 80px);
  overflow-x: hidden;
`

const TextColumn = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 424px;

  @media (max-width: 900px) {
    padding: 8px;
    border-radius: 8px;
    background-color: ${colors.translucentWhite30};
    backdrop-filter: blur(5px);
  }
`

const TextPadding = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: center;
`

const LogoRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 8px;
  align-items: center;
  margin-bottom: 20px;
`

const DigitsLogo = styled(SvgDigitsLogoNoBackground)`
  height: 38px;
  width: 38px;
  min-width: 38px;
  display: block;
  ${svgIconStyles(colors.secondary)}
`

const DigitsWordmark = styled(SvgDigitsWordmark)`
  min-height: 38px;
  max-height: 38px;
  width: 84px;
  padding: 0;
  ${svgIconStyles(colors.secondary)};
`

/*
  COMPONENTS
*/

export const SharedWithMeCallToAction: React.FC = () => (
  <SharedWithMeCallToActionContainer>
    <TextPadding>
      <TextColumn>
        <LogoRow>
          <DigitsLogo />
          <DigitsWordmark />
        </LogoRow>
        <H1Text weight="normal">Introducing: The World's First Autonomous General Ledger.</H1Text>
      </TextColumn>
    </TextPadding>
    <ImageWidthPlaceholder />
    <CTAImage src={require("static/images/sharing/background.png")} />
  </SharedWithMeCallToActionContainer>
)
